<script>
import {resetObject, setObject} from '../../common/util';
export default {
  props: {
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      editOption: {
          type: Object
      },
      selectOptions: {
          type: Object
      }
  },
  data() {
      return {
          upload: {
              url: `${location.origin}/admin/api/carousel/V1.0/photo`
          },
          editQuery: {
              id: '',
              name: '',
              address: '',
              link: '',
              startTime: '',
              endTime: '',
              sort: '',
              type: ''
          },
          files: [],
          header: {
              token: this.$store.state.env.userInfo.token
          }
      }
  },
  methods: {
      initQuery(row) {
          this.$refs.carousel.clearValidate();
          this.files = [];
          this.$clearObject(this.editQuery);
          const type = this.editOption.type;
          console.log(this.editQuery, row);
          Object.is(type, 1) && setObject(this.editQuery, row);
      },
      async submit() {
        const {code} = await this.codeEvent(this.editQuery);
        if (Object.is(code, 200)) {
            this.editOption.dialog = false;
            this.$message.success(`${this.editOption.title}成功`);
            this.searchEvent();
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleSuccess(res) {
          const {code, data} = res;
          if (code === 200) {
              this.editQuery.address = data;
          } else {
              this.$refs.upload.clearFiles();
              this.$message.error('文件上传失败');
          }
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      submitForm(formName) {
           this.$refs[formName].validate((valid) => {
           valid && this.submit();
        });
      }
  },
  mounted() {
  },
  computed: {
  },
}
</script>
<template>
<div class="edit">
<el-dialog
    :title="editOption.title"
    :width="editOption.width"
    :visible.sync="editOption.dialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="editQuery" ref="carousel">
      <el-form-item label="名称" label-width="80px" prop="name"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.name"
            class="common-width9"
          ></el-input>
      </el-form-item>
      <!-- <el-form-item label="图片类型" label-width="80px" prop="type"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.type" class="common-width9"
			    placeholder="图片类型"
			>
                <el-option :value=1 label="首页"></el-option>
                <el-option :value=2 label="项目融资"></el-option>
			</el-select>
      </el-form-item> -->
       <el-form-item label="图片类型" label-width="80px" prop="type"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-select v-model="editQuery.type" class="common-width9"
			    placeholder="图片类型"
			>
				<el-option
					v-for="item in selectOptions.type"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
      </el-form-item>
      <el-form-item label="图片地址" label-width="80px" prop="address" v-if="editOption.type===0"
        :rules="[{required: editOption.type===0, message: '不能为空', trigger: 'blur'}]">
          <el-upload res="upload"
            :action="upload.url"
            :on-remove="handleRemove"
            accept="image/*"
            :limit="1"
            :file-list="files"
            :headers="header"
            :on-success="handleSuccess"
          >
            <el-button size="small" type="primary">点击上传</el-button>
         </el-upload>
      </el-form-item>
      <el-form-item label="外链地址" label-width="80px" prop="link"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.link"  class="common-width9"></el-input>
      </el-form-item>
      <el-form-item label="位置" label-width="80px" prop="sort"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-input v-model="editQuery.sort" type="number"
            placeholder="请输入位置"
            class="common-width9"
          ></el-input>
      </el-form-item>
      <el-form-item label="开始时间" label-width="80px" prop="startTime"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
            <el-date-picker class="common-width9"
				v-model="editQuery.startTime"
				type="datetime"
				placeholder="选择开始时间"
				value-format="yyyy-MM-dd HH:mm:ss"
			>
			</el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间" label-width="80px" prop="endTime"
        :rules="[{required: true, message: '不能为空', trigger: 'blur'}]">
          <el-date-picker class="common-width9"
				v-model="editQuery.endTime"
				type="datetime"
				placeholder="选择结束时间"
				value-format="yyyy-MM-dd HH:mm:ss"
			>
			</el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="editOption.dialog = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submitForm('carousel')" size="small"
         >提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">

</style>
